export const COOKIE_SWIPE_EXPLAINER = 'swipe_hint'

export const COOKIE_SCRATCHCARD_TUTORIAL = 'scratchmode_tutorial_visited'

export const COOKIE_HIGH_FREQUENCY_GAME_TUTORIAL = 'high_frequency_game_tutorial_visited'

export const COOKIE_HIGH_FREQUENCY_DISCLAIMER_ACCEPTED = 'high_frequency_game_disclaimer_accepted'

export const COOKIE_LEGACY_WARNING = 'legacy_warning'
